import axios from 'axios'
import {
  Message
} from 'element-ui'
import router from '@/router/index'
import store from '@/store/';
import commonMethods from '@/mixins/commonMethods'
import { ssoLinkApi } from '@/settings'

const request = axios.create({
  baseURL: ssoLinkApi, // 注意！！ 这里是全局统一加上了 '/api' 前缀，也就是说所有接口都会加上'/api'前缀在，页面里面写接口的时候就不要加 '/api'了，否则会出现2个'/api'，类似 '/api/api/user'这样的报错，切记！！！
  timeout: 5000,
  withCredentials: true
})

// request 拦截器
// 可以自请求发送前对请求做一些处理
// 比如统一加token，对请求参数统一加密
request.interceptors.request.use(config => {
  console.log(config, 'config')
  config.headers['Content-Type'] = 'application/json;charset=utf-8'
  // 用统一登录的token
  config.headers['token'] = localStorage.getItem('loginToken')
  // 20240229 注释 || sessionStorage.getItem('loginToken'); // 设置请求头
  // 获取保持登录有效期
  // commonMethods.methods.getLocalExpire('logonExpire')
  return config
}, error => {
  return Promise.reject(error)
})

// response 拦截器
// 可以在接口响应后统一处理结果
request.interceptors.response.use(
  response => {
    let res = response.data
    // 如果是返回的文件
    if (response.config.responseType === 'blob') {
      return res
    }
    // 兼容服务端返回的字符串数据
    if (typeof res === 'string') {
      res = res ? JSON.parse(res) : res
    }
    console.log(111)
    // if (status === 401) store.dispatch('FedLogOut').then(() => router.push({path: '/login'}));
    if (res.code === 200) {
      // 重置登录状态
      commonMethods.methods.resetLogin()
    } else if (res.code === 401) {
      // 重置登录状态
      commonMethods.methods.resetLogin()
    }
    return res
  },
  error => {
    Message.error('网络错误，请重新加载')
    console.log('err' + error) // for debug
    return Promise.reject(error)
  }
)

export default request



// WEBPACK FOOTER //
// ./src/api/axiosSec.js